import * as types from '../actions/types';

const initialState = {
  isError: false,
  error: null
};

const rematchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REMATCH_REQUESTED:
      return {
        ...state,
        isError: false,
        error: null
      };
    case types.REMATCH_SUCCEEDED:
      return {
        ...state,
        isError: false,
        error: null
      };
    case types.REMATCH_FAILED:
      return {
        ...state,
        isError: true,
        error: action.error
      };
    default:
      return state;
  }
};

export default rematchReducer;
